import { TenantType } from '../user/enums';

export const USER_TYPES = Object.values(TenantType);

export type UserType = {
    user: (typeof USER_TYPES)[0];
};
